import { settings } from "../../main/configs/settings";

export const getFileURL = (file: File): string =>
  window.URL.createObjectURL(file);

export const getFileByFilename = (filename: string): string =>
  `${settings.ASSETS_URL}/${filename}`;

export const urlToFile = async (
  url: string,
  name: string,
  defaultType = "image/jpeg",
): Promise<File> => {
  const response = await fetch(url);
  const data = await response.blob();
  return new File([data], name, {
    type: data.type || defaultType,
  });
};

export const readDocumentAsBase64 = (
  doc: Blob,
): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(doc);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const adjustMimeTypeToPdf = (
  base64String: string | ArrayBuffer | null,
): string => {
  if (typeof base64String === "string") {
    return base64String.replace(
      "data:application/octet-stream;base64",
      "data:application/pdf;base64",
    );
  }
  return "";
};
